/* eslint-disable react/jsx-no-useless-fragment */
import React, { useCallback, useMemo } from "react";
import { Image } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import NewTool from "./NewTool";
import { calculatorAndToolsResoucesLandingSlugs, calculatorAndToolsSlugs, headerSlugs, repo } from "../../../utils/commonRouteUrl";
import { getTerminology } from "../../../containers/mentalHealth/selectors/user";
import useMobile from "../../../hooks/useMobile";

const libraryRoute = [headerSlugs?.blog, headerSlugs?.resource];
const marketPlaceRoute = [headerSlugs?.insurance, headerSlugs?.memberBenefits];
const supportRoute: any = [headerSlugs?.reportAProblem, headerSlugs?.requestAFeature];
const toolboxRoute: any = [
  calculatorAndToolsSlugs?.therapyNotesGenerator(),
  calculatorAndToolsSlugs?.paperworkAndFormGenerator(),
  calculatorAndToolsSlugs?.therapistDeductionsCalculator(),
  calculatorAndToolsSlugs?.sessionFeeCalculator(),
  calculatorAndToolsSlugs?.goodFaithEstimateCalculator(),
  calculatorAndToolsSlugs?.outOfNetworkCalculator(),
  calculatorAndToolsSlugs?.superbillGenerator(),
  calculatorAndToolsResoucesLandingSlugs?.therapyNotesGenerator(),
  calculatorAndToolsResoucesLandingSlugs?.paperworkAndFormGenerator(),
  calculatorAndToolsResoucesLandingSlugs?.therapistDeductionsCalculator(),
  calculatorAndToolsResoucesLandingSlugs?.sessionFeeCalculator(),
  calculatorAndToolsResoucesLandingSlugs?.goodFaithEstimateCalculator(),
  calculatorAndToolsResoucesLandingSlugs?.outOfNetworkCalculator(),
  calculatorAndToolsResoucesLandingSlugs?.superbillGenerator(),
];

type ATagMenuProp = {
  item: any;
  proRouteUrl: any;
  activeClass: any;
  noRouteMenuHandler: any;
  menuId: any;
  openSubMenuHandler: any;
  setIsSidebarOpen: any;
  handleSearchClick: any;
  isReactRoute: any;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
function LeftSubMenu({
  item,
  proRouteUrl,
  activeClass,
  noRouteMenuHandler,
  menuId,
  openSubMenuHandler,
  setIsSidebarOpen,
  handleSearchClick,
  isReactRoute,
}: ATagMenuProp) {
  const router = useLocation();
  const isTablet = useMobile(1024);
  const paymentHistory = useSelector((state: any) => state.my_account.paymenthistory);
  const closeMenuHandler = useCallback(() => {
    setIsSidebarOpen(false);
  }, [setIsSidebarOpen]);
  const unreadNotifications = useSelector((state: any) => state?.notifications?.notifications?.filter((i: any) => i.read_status === 0).length);
  const terminology = useSelector(getTerminology);
  const routePath: any = useMemo(() => {
    return router?.pathname;
  }, [router]);
  const routeActiveTrue = useMemo(() => {
    return `${item.key !== "notification" && router?.pathname?.includes(item?.route) ? "active" : ""} ${
      item.key === "library" && libraryRoute?.includes(router?.pathname) ? "active" : ""
    } ${item.key === "market_place" && marketPlaceRoute?.includes(routePath) ? "active" : ""}
    ${item.key === "support" && supportRoute?.includes(routePath) ? "active" : ""}
    ${item.key === "toolbox" && toolboxRoute?.includes(routePath) ? "active" : ""}
    ${item.key === "toolbox" && router?.pathname?.includes("/super-bill/page") ? "active" : ""}`;
  }, [item.key, item?.route, routePath, router?.pathname]);
  return (
    <li id={item.id} key={item.key} className={`${!item?.subRoutes ? "" : "dropmenu"} `}>
      {item?.key !== "notification" && (
        <div
          aria-hidden
          id={`${item.key}`}
          className={`menuItem ${routeActiveTrue}
    `}
          onClick={() => {
            openSubMenuHandler(item);
          }}
        >
          {item?.repo !== repo?.next && (
            <>
              {!item?.noRoute ? (
                <>
                  {item.subRoutes && isTablet ? (
                    <span aria-hidden className={` ${router?.pathname?.includes(item?.route) ? "active" : ""}`} onClick={() => closeMenuHandler()}>
                      {item?.svgImage ? <Image className="menuSvgIcon ml-2" src={item?.svgImage} /> : <i className={`menuIcon ${item?.icon}`} />}
                    </span>
                  ) : (
                    <span
                      aria-hidden
                      onClick={() => {
                        handleSearchClick(
                          item?.route,
                          isReactRoute(proRouteUrl(item?.backupRoute, item?.proRoute, item?.route)),
                          item?.proRoute,
                          item?.backupRoute,
                        );
                        closeMenuHandler();
                      }}
                      className={` ${router?.pathname?.includes(item?.route) ? "active" : ""}`}
                    >
                      {item?.svgImage ? <Image className="menuSvgIcon ml-2" src={item?.svgImage} /> : <i className={`menuIcon ${item?.icon}`} />}
                    </span>
                  )}
                </>
              ) : (
                // eslint-disable-next-line react/jsx-no-useless-fragment
                <>{item?.svgImage ? <Image className="menuSvgIcon ml-2" src={item?.svgImage} /> : <i className={`menuIcon ${item?.icon}`} />}</>
              )}
              {!item?.noRoute ? (
                <>
                  {item.subRoutes && isTablet ? (
                    <span
                      aria-hidden
                      className={`menuTitle ${router?.pathname?.includes(item?.route) ? "active" : ""}`}
                      onClick={() => {
                        handleSearchClick(
                          item?.route,
                          isReactRoute(proRouteUrl(item?.backupRoute, item?.proRoute, item?.route)),
                          item?.proRoute,
                          item?.backupRoute,
                        );
                        closeMenuHandler();
                      }}
                    >
                      {item?.name} {item?.beta && <NewTool text={item?.betaText} />}
                    </span>
                  ) : (
                    <span
                      aria-hidden
                      onClick={() => {
                        handleSearchClick(
                          item?.route,
                          isReactRoute(proRouteUrl(item?.backupRoute, item?.proRoute, item?.route)),
                          item?.proRoute,
                          item?.backupRoute,
                        );
                        closeMenuHandler();
                      }}
                      className={`menuTitle ${router?.pathname?.includes(item?.route) ? "active" : ""}`}
                    >
                      {item?.name} {item?.beta && <NewTool text={item?.betaText} />}
                    </span>
                  )}
                </>
              ) : (
                <div aria-hidden className="menuTitle">
                  {item?.key === "my_patients" ? `My ${terminology}s` : item?.name} {item?.beta && <NewTool text={item?.betaText} />}
                </div>
              )}
            </>
          )}

          {!item?.noRoute && item?.repo === repo?.next && (
            <>
              {item.subRoutes && isTablet ? (
                <>
                  <span aria-hidden onClick={() => closeMenuHandler()}>
                    {item?.svgImage ? <Image className="menuSvgIcon ml-2" src={item?.svgImage} /> : <i className={`menuIcon ${item?.icon}`} />}
                  </span>
                  <span
                    aria-hidden
                    className="menuTitle"
                    onClick={() => {
                      handleSearchClick(
                        item?.route,
                        isReactRoute(proRouteUrl(item?.backupRoute, item?.proRoute, item?.route)),
                        item?.proRoute,
                        item?.backupRoute,
                      );
                      closeMenuHandler();
                    }}
                  >
                    {item?.key === "my_patients" ? `My ${terminology}s` : item?.name} {item?.beta && <NewTool text={item?.betaText} />}
                  </span>
                </>
              ) : (
                <>
                  <span
                    aria-hidden
                    onClick={() => {
                      handleSearchClick(
                        item?.route,
                        isReactRoute(proRouteUrl(item?.backupRoute, item?.proRoute, item?.route)),
                        item?.proRoute,
                        item?.backupRoute,
                      );
                      closeMenuHandler();
                    }}
                  >
                    {item?.svgImage ? <Image className="menuSvgIcon ml-2" src={item?.svgImage} /> : <i className={`menuIcon ${item?.icon}`} />}
                  </span>
                  <span
                    className="menuTitle"
                    aria-hidden
                    onClick={() => {
                      handleSearchClick(
                        item?.route,
                        isReactRoute(proRouteUrl(item?.backupRoute, item?.proRoute, item?.route)),
                        item?.proRoute,
                        item?.backupRoute,
                      );
                      closeMenuHandler();
                    }}
                  >
                    {item?.key === "my_patients" ? `My ${terminology}s` : item?.name} {item?.beta && <NewTool text={item?.betaText} />}
                  </span>
                </>
              )}
            </>
          )}
        </div>
      )}

      {item?.key === "notification" && (
        <div
          aria-hidden
          onClick={() => {
            noRouteMenuHandler(item);
          }}
          id={`${item.key}`}
          className={`menuItem ${routeActiveTrue} cursor-pointer
    `}
        >
          <i className={`menuIcon ${item?.icon} ${!!unreadNotifications && "position-relative"}`}>
            {!!unreadNotifications && <span className="activeNotification">{unreadNotifications}</span>}
          </i>
          <span className="menuTitle">{item?.name}</span>
        </div>
      )}

      <ul
        className={`submenu ${item?.key === menuId && item?.subRoutes?.length > 0 ? "active" : ""} ${!item.subRoutes ? "singleMenu" : ""}`}
        id={`${item.id}Sub`}
      >
        {item?.noRoute && (
          <li
            aria-hidden
            onClick={() => {
              noRouteMenuHandler(item);
            }}
            className="subMenuTitle cursor-pointer"
            id={item?.key}
          >
            {" "}
            {item?.key === "my_patients" ? `My ${terminology}s` : item?.name}
          </li>
        )}
        {!item?.noRoute && (
          <span
            aria-hidden
            onClick={() => {
              handleSearchClick(item?.route, isReactRoute(proRouteUrl(item?.backupRoute, item?.proRoute, item?.route)), item?.proRoute, item?.backupRoute);
              closeMenuHandler();
            }}
            className="subMenuTitle cursor-pointer"
          >
            {item?.key === "my_patients" ? `My ${terminology}s` : item?.name}
          </span>
        )}

        {item?.subRoutes?.length > 0 &&
          item?.subRoutes?.map((subMenu: any) => {
            return (
              <>
                {subMenu?.route && (
                  <>
                    {subMenu?.repo === repo?.next ? (
                      <>
                        {subMenu?.key === "my_account_payments" && paymentHistory?.data?.length > 0 && (
                          <li
                            //   className={activeClass(`${item?.route}`)}
                            key={subMenu?.name}
                          >
                            <span
                              aria-hidden
                              onClick={() => {
                                handleSearchClick(
                                  subMenu?.route,
                                  isReactRoute(proRouteUrl(subMenu?.backupRoute, subMenu?.proRoute, subMenu?.route)),
                                  subMenu?.proRoute,
                                  subMenu?.backupRoute,
                                  subMenu,
                                );
                                closeMenuHandler();
                              }}
                              className={`menuItem ${activeClass(subMenu?.route)}`}
                            >
                              <i className={`menuIcon ${subMenu?.icon}`} />
                              <span className="menuTitle">{subMenu?.name}</span>
                              {subMenu?.beta && <NewTool text={subMenu?.betaText} />}
                            </span>
                          </li>
                        )}
                        {subMenu?.openInNewTabUrl && subMenu?.key !== "my_account_payments" ? (
                          <li
                          //   className={activeClass(`${item?.route}`)}
                          >
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={`${proRouteUrl(subMenu?.backupRoute, subMenu?.proRoute, subMenu?.route)}`}
                              className={`menuItem ${activeClass(subMenu?.route)}`}
                              onClick={() => closeMenuHandler()}
                            >
                              <i className={`menuIcon ${subMenu?.icon}`} />
                              <span className="menuTitle">{subMenu?.name}</span>
                              {subMenu?.beta && <NewTool text={subMenu?.betaText} />}
                            </a>
                          </li>
                        ) : (
                          // eslint-disable-next-line react/jsx-no-useless-fragment
                          <>
                            {subMenu?.key !== "my_account_payments" && (
                              <li
                                //   className={activeClass(`${item?.route}`)}
                                key={subMenu?.name}
                              >
                                <span
                                  aria-hidden
                                  onClick={() => {
                                    handleSearchClick(
                                      subMenu?.route,
                                      isReactRoute(proRouteUrl(subMenu?.backupRoute, subMenu?.proRoute, subMenu?.route)),
                                      subMenu?.proRoute,
                                      subMenu?.backupRoute,
                                      subMenu,
                                    );
                                    closeMenuHandler();
                                  }}
                                  className={`menuItem ${activeClass(subMenu?.route)}`}
                                >
                                  <i className={`menuIcon ${subMenu?.icon}`} />
                                  <span className="menuTitle cursor-pointer">{subMenu?.name}</span>
                                  {subMenu?.beta && <NewTool text={subMenu?.betaText} />}
                                </span>
                              </li>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      // eslint-disable-next-line react/jsx-no-useless-fragment
                      <>
                        {subMenu?.key !== "my_account_payments" && (
                          <li
                            //   className={activeClass(`${item?.route}`)}
                            key={subMenu?.name}
                          >
                            <span
                              aria-hidden
                              onClick={() => {
                                handleSearchClick(
                                  subMenu?.route,
                                  isReactRoute(proRouteUrl(subMenu?.backupRoute, subMenu?.proRoute, subMenu?.route)),
                                  subMenu?.proRoute,
                                  subMenu?.backupRoute,
                                  subMenu,
                                );
                                closeMenuHandler();
                              }}
                              className={`menuItem ${activeClass(subMenu?.route)}`}
                            >
                              <i className={`menuIcon ${subMenu?.icon}`} />
                              <span className="menuTitle cursor-pointer">{subMenu?.name}</span>
                              {subMenu?.beta && <NewTool text={subMenu?.betaText} />}
                            </span>
                          </li>
                        )}
                      </>
                    )}
                  </>
                )}

                {!subMenu?.route && (
                  <li
                    aria-hidden
                    onClick={() => {
                      noRouteMenuHandler(subMenu);
                    }}
                    key={subMenu?.key}
                    className="cursor-pointer"
                  >
                    <div className="menuItem">
                      <i className={`menuIcon ${subMenu?.icon}`} />
                      <span className="menuTitle">{subMenu?.name}</span>
                    </div>
                  </li>
                )}
              </>
            );
          })}
      </ul>
    </li>
  );
}

export default LeftSubMenu;
